import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formValueContainsUpperCaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /[A-Z]/;
    return regex.test(control.value) ? null : { NoContainUpperCase: true };
  };
}
